import { render } from "./HeaderSectionExtranjeros.vue?vue&type=template&id=024a8697"
import script from "./HeaderSectionExtranjeros.vue?vue&type=script&lang=js"
export * from "./HeaderSectionExtranjeros.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__